module.exports = __webpack_public_path__ + "img/web design.f1cb8678.png";